module.exports = __webpack_public_path__ + "img/YST.e4395dd1.png";